/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocEditIcon24Solid = forwardRef('DocEditIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12.05 2H8a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h3v-.172a2 2 0 0 1 .586-1.414L20 12v-1.95h-5.2a2.75 2.75 0 0 1-2.75-2.75V2Z" }),
        React.createElement("path", { d: "m20 8.55-6.45-6.49V7.3c0 .69.56 1.25 1.25 1.25H20Z" }),
        React.createElement("path", { d: "M13 21.914V23.5a.5.5 0 0 0 .5.5h1.586a1 1 0 0 0 .707-.293l5.854-5.854-2.5-2.5-5.854 5.854a1 1 0 0 0-.293.707Z" }),
        React.createElement("path", { d: "m23.677 15.823-1.323 1.323-2.5-2.5 1.323-1.323a1 1 0 0 1 1.414 0l1.086 1.086a1 1 0 0 1 0 1.414Z" })));
});
